export default [
  {
    path: 'explore',
    name: 'explore',
    component: () => import('./site-list/SiteListPage.vue')
  },
  {
    path: 'explore/site/:uuid',
    name: 'site.detail',
    component: () => import('./site-detail/SiteDetailPage.vue')
  }
]
